import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectUserProject } from 'core/userContext';

import { PROJECT_ID_SEARCH_PARAM_KEY } from '../../constants';

/**
 * React hook that adds a project ID to the current URL's search parameters
 * if one is not already set. This can be used by pages that want to namespace
 * other search parameters by project. Add this to a page component to allow
 * users to bookmark or permalink search parameter combinations for a particular
 * project.
 */
export const useProjectIdSearchParamOnMount = () => {
  const currentProjectIdInSessionCookie = useSelector(selectUserProject)?.id;

  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    if (
      currentProjectIdInSessionCookie !== undefined &&
      currentUrl.searchParams.get(PROJECT_ID_SEARCH_PARAM_KEY) === null
    ) {
      currentUrl.searchParams.set(
        PROJECT_ID_SEARCH_PARAM_KEY,
        currentProjectIdInSessionCookie.toString(),
      );
      window.history.replaceState({}, '', currentUrl.toString());
    }
  }, []);
};
